export const SUPPORTED_FUTURE_DAYS = 7;

export const SUPPORTED_POTENTIAL_REGULATIONS = [
  "brazil",
  "ec261",
  "uk261",
  "tr_shy",
  "ca_goodwill",
  "us_goodwill",
  "us",
  "mcxx",
  "saudi_arabia",
] as const;

export const SUPPORTED_CLAIM_TYPES = ["delayed", "cancelled", "overbooked"] as const;

export const SUPPORTED_ARRIVAL_STATUSES = [
  "delayed",
  "no_status",
  "cancelled",
  "early",
  "on_time",
] as const;

export const CLAIM_TYPES_WITH_TRANSLATIONS = {
  delayed: "steps.claim_type.delayed",
  cancelled: "steps.claim_type.cancelled",
  overbooked: "steps.claim_type.overbooked",
} as const;

export const SUPPORTED_DELAYS = [
  "lt1",
  "lt2",
  "lt3",
  "gt1_lt2",
  "gt2_lt3",
  "gt2_lt4",
  "gt3_lt4",
  "gt3_lt5",
  "gt4_lt5",
  "gt5_lt6",
  "gt5_lt9",
  "gt6_lt7",
  "gt7_lt8",
  "gt8_lt9",
  "lt4",
  "gt2",
  "gt3",
  "gt4",
  "gt9",
  "never",
] as const;

export const SUPPORTED_ELIGIBILITY_RESULTS = ["eligible", "ineligible", "no_response"] as const;

export const DEFAULT_DELAY_OPTIONS = ["gt3", "lt3", "never"] as const;

export const DEFAULT_DELAY_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof DEFAULT_DELAY_OPTIONS
> = {
  gt3: "steps.total_delay.gt3",
  lt3: "steps.total_delay.lt3",
  never: "steps.total_delay.never",
} as const;

export const US_GOODWILL_DELAY_OPTIONS = ["gt2", "lt2", "never"] as const;

export const US_GOODWILL_DELAY_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof US_GOODWILL_DELAY_OPTIONS
> = {
  gt2: "steps.total_delay.us_goodwill.gt2",
  lt2: "steps.total_delay.us_goodwill.lt2",
  never: "steps.total_delay.us_goodwill.never",
};

export const BRAZIL_DELAY_OPTIONS = ["lt2", "gt2_lt4", "gt4", "never"] as const;

export const BRAZIL_DELAY_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof BRAZIL_DELAY_OPTIONS
> = {
  lt2: "steps.total_delay.brazil.lt2",
  gt2_lt4: "steps.total_delay.brazil.bt2-4",
  gt4: "steps.total_delay.brazil.gt4",
  never: "steps.total_delay.brazil.never",
} as const;

export const SAUDI_DELAY_OPTIONS = [
  "lt1",
  "gt1_lt2",
  "gt2_lt3",
  "gt3_lt4",
  "gt4_lt5",
  "gt5_lt6",
  "gt6_lt7",
  "gt7_lt8",
  "gt8_lt9",
  "gt9",
  "never",
] as const;

export const SAUDI_DELAY_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof SAUDI_DELAY_OPTIONS
> = {
  lt1: "steps.total_delay.saudi_arabia.lt1",
  gt1_lt2: "steps.total_delay.saudi_arabia.gt1_lt2",
  gt2_lt3: "steps.total_delay.saudi_arabia.gt2_lt3",
  gt3_lt4: "steps.total_delay.saudi_arabia.gt3_lt4",
  gt4_lt5: "steps.total_delay.saudi_arabia.gt4_lt5",
  gt5_lt6: "steps.total_delay.saudi_arabia.gt5_lt6",
  gt6_lt7: "steps.total_delay.saudi_arabia.gt6_lt7",
  gt7_lt8: "steps.total_delay.saudi_arabia.gt7_lt8",
  gt8_lt9: "steps.total_delay.saudi_arabia.gt8_lt9",
  gt9: "steps.total_delay.saudi_arabia.gt9",
  never: "steps.total_delay.saudi_arabia.never",
} as const;

export const TR_SHY_DELAYED_OPTIONS = ["lt3", "gt3_lt5", "gt5_lt9", "gt9", "never"] as const;

export const TR_SHY_DELAYED_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof TR_SHY_DELAYED_OPTIONS
> = {
  lt3: "steps.total_delay.tr_shy.delayed.lt3",
  gt3_lt5: "steps.total_delay.tr_shy.delayed.gt3_lt5",
  gt5_lt9: "steps.total_delay.tr_shy.delayed.gt5_lt9",
  gt9: "steps.total_delay.tr_shy.delayed.gt9",
  never: "steps.total_delay.tr_shy.delayed.never",
} as const;

export const TR_SHY_CANCELLED_OPTIONS = ["lt2", "gt2_lt4", "gt4", "never"] as const;

export const TR_SHY_CANCELLED_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof TR_SHY_CANCELLED_OPTIONS
> = {
  lt2: "steps.total_delay.tr_shy.cancelled.lt2",
  gt2_lt4: "steps.total_delay.tr_shy.cancelled.gt2_lt4",
  gt4: "steps.total_delay.tr_shy.cancelled.gt4",
  never: "steps.total_delay.tr_shy.cancelled.never",
} as const;

export const TR_SHY_OVERBOOKED_OPTIONS = ["lt2", "gt2_lt3", "gt3_lt4", "gt4", "never"] as const;

export const TR_SHY_OVERBOOKED_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof TR_SHY_OVERBOOKED_OPTIONS
> = {
  lt2: "steps.total_delay.tr_shy.denied_boarding.lt2",
  gt2_lt3: "steps.total_delay.tr_shy.denied_boarding.gt2_lt3",
  gt3_lt4: "steps.total_delay.tr_shy.denied_boarding.gt3_lt4",
  gt4: "steps.total_delay.tr_shy.denied_boarding.gt4",
  never: "steps.total_delay.tr_shy.denied_boarding.never",
} as const;

export const SUPPORTED_DELAY_MINUTES = [
  { min: "1", max: "60" },
  { min: "1", max: "119" },
  { min: "1", max: "179" },
  { min: "61", max: "120" },
  { min: "121", max: "180" },
  { min: "121", max: "240" },
  { min: "181", max: "240" },
  { min: "181", max: "300" },
  { min: "180", max: "infinity" },
  { min: "1", max: "240" },
  { min: "241", max: "300" },
  { min: "301", max: "360" },
  { min: "361", max: "420" },
  { min: "421", max: "480" },
  { min: "481", max: "540" },
  { min: "301", max: "540" },
  { min: "120", max: "infinity" },
  { min: "241", max: "infinity" },
  { min: "541", max: "infinity" },
  { min: "never", max: "never" },
] as const;

export const SUPPORTED_INFORMED_BEFOREHAND = [
  "lt1",
  "lt3",
  "lt6",
  "lt14",
  "gt3",
  "gt7_lt13",
  "gt14_lt60",
  "gt14",
  "gt60",
] as const;

export const SUPPORTED_INFORMED_BEFOREHAND_DAYS = [
  { min: "0", max: "1" },
  { min: "1", max: "13" },
  { min: "1", max: "3" },
  { min: "1", max: "6" },
  { min: "7", max: "13" },
  { min: "4", max: "infinity" },
  { min: "14", max: "60" },
  { min: "14", max: "infinity" },
  { min: "60", max: "infinity" },
] as const;

export const BRAZIL_INFORMED_BEFOREHAND_DAYS_OPTIONS = ["lt3", "gt3"] as const;

export const TR_SHY_INFORMED_BEFOREHAND_DAYS_OPTIONS = ["lt6", "gt7_lt13", "gt14"] as const;

export const SAUDI_INFORMED_BEFOREHAND_DAYS_OPTIONS = ["lt1", "lt14", "gt14_lt60", "gt60"] as const;

export const DEFAULT_INFORMED_BEFOREHAND_DAYS_OPTIONS = ["lt14", "gt14"] as const;

export const DEFAULT_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof DEFAULT_INFORMED_BEFOREHAND_DAYS_OPTIONS
> = {
  lt14: "steps.informed_beforehand.lt14",
  gt14: "steps.informed_beforehand.gt14",
} as const;

export const BRAZIL_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof BRAZIL_INFORMED_BEFOREHAND_DAYS_OPTIONS
> = {
  lt3: "steps.informed_beforehand.brazil.lt3",
  gt3: "steps.informed_beforehand.brazil.gt3",
} as const;

export const TR_SHY_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof TR_SHY_INFORMED_BEFOREHAND_DAYS_OPTIONS
> = {
  lt6: "steps.informed_beforehand.tr_shy.lt6",
  gt7_lt13: "steps.informed_beforehand.tr_shy.gt7_lt13",
  gt14: "steps.informed_beforehand.tr_shy.gt14",
} as const;

export const SAUDI_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS: OptionsWithTranslations<
  typeof SAUDI_INFORMED_BEFOREHAND_DAYS_OPTIONS
> = {
  lt1: "steps.informed_beforehand.saudi_arabia.lt1",
  lt14: "steps.informed_beforehand.saudi_arabia.lt14",
  gt14_lt60: "steps.informed_beforehand.saudi_arabia.gt14_lt60",
  gt60: "steps.informed_beforehand.saudi_arabia.gt60",
} as const;

export const INFORMED_BEFOREHAND_TO_DAYS_MAP: InformedBeforehandToHoursMap = {
  lt1: { min: "0", max: "1" },
  lt3: { min: "1", max: "3" },
  lt6: { min: "1", max: "6" },
  lt14: { min: "1", max: "13" },
  gt14_lt60: { min: "14", max: "60" },
  gt3: { min: "4", max: "infinity" },
  gt7_lt13: { min: "7", max: "13" },
  gt14: { min: "14", max: "infinity" },
  gt60: { min: "60", max: "infinity" },
} as const;

export const DELAY_TO_MINUTES_MAP: DelayToMinutesMap = {
  lt1: { min: "1", max: "60" },
  lt2: { min: "1", max: "119" },
  lt3: { min: "1", max: "179" },
  gt1_lt2: { min: "61", max: "120" },
  gt2_lt3: { min: "121", max: "180" },
  gt2_lt4: { min: "121", max: "240" },
  gt3_lt4: { min: "181", max: "240" },
  gt3_lt5: { min: "181", max: "300" },
  gt4_lt5: { min: "241", max: "300" },
  gt5_lt6: { min: "301", max: "360" },
  gt6_lt7: { min: "361", max: "420" },
  gt7_lt8: { min: "421", max: "480" },
  gt8_lt9: { min: "481", max: "540" },
  gt5_lt9: { min: "301", max: "540" },
  lt4: { min: "1", max: "240" },
  gt2: { min: "120", max: "infinity" },
  gt3: { min: "180", max: "infinity" },
  gt4: { min: "241", max: "infinity" },
  gt9: { min: "541", max: "infinity" },
  never: { min: "never", max: "never" },
} as const;

type DelayOptions = (typeof SUPPORTED_DELAYS)[number];
type InformedBeforehandOptions = (typeof SUPPORTED_INFORMED_BEFOREHAND)[number];

type DelayMinutes = (typeof SUPPORTED_DELAY_MINUTES)[number];
type InformedBeforehandDays = (typeof SUPPORTED_INFORMED_BEFOREHAND_DAYS)[number];

type OptionsWithTranslations<T extends readonly string[]> = {
  [_key in T[number]]: string;
};

type InformedBeforehandToHoursMap = {
  [_key in InformedBeforehandOptions]: InformedBeforehandDays;
};

type DelayToMinutesMap = {
  [_key in DelayOptions]: DelayMinutes;
};
